import { __decorate } from "tslib";
import { AsnProp } from "@peculiar/asn1-schema";
import { CertID } from "./cert_id";
import { Extension } from "@peculiar/asn1-x509";
export class Request {
    constructor(params = {}) {
        this.reqCert = new CertID();
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: CertID })
], Request.prototype, "reqCert", void 0);
__decorate([
    AsnProp({ type: Extension, repeated: "sequence", optional: true })
], Request.prototype, "singleRequestExtensions", void 0);
